(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/competition/core/assets/javascripts/models/participated-draw.js') >= 0) return;  svs.modules.push('/components/competition/core/assets/javascripts/models/participated-draw.js'); 'use strict';

svs.competition.core.models.ParticipatedDraw = Backbone.Model.extend({
  initialize: function(drawNumber) {
    this.set('drawNumber', drawNumber);
  }
});

 })(window);